// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"692":"d2af4d68","4041":"a8759fee","7467":"d2af4d68"}[chunkId] + ".chunk.css";
};